import axios from "axios";
import { useDispatch } from "react-redux";
import { newsSuccess } from "../features/newsSlice";

const useNewsCalls = () => {
  const dispatch = useDispatch();
  const API_KEY = "3722ef6d21924e0197ec0767a3a6933e";
  const url = `https://newsapi.org/v2/everything?&apiKey=${API_KEY}&page=1&pageSize=5`;

  const getNewsData = async (page) => {
    try {
      const data = await axios(
        ` https://newsdata.io/api/1/news?apikey=pub_38945c7f584e8330f2c02252fd23d0f96fa03&category=technology&language=en&size=5&country=us`
      );
      dispatch(newsSuccess(data.data.results));
      console.log(data.data.results);

      return data;
    } catch (error) {
      console.log(error);
    }
  };

  return getNewsData;
};

export default useNewsCalls;
